import {ChangeDetectorRef, Component, HostBinding, Input} from '@angular/core';

@Component({
  selector: 'arc-diagram',
  templateUrl: 'arc-diagram.html',
  styleUrls: ['arc-diagram.scss'],
})
export class ArcDiagramComponent {

  @HostBinding("style.--offset1")  public offset1: number = 0;
  @HostBinding("style.--offset2")  public offset2: number = 0;
  @HostBinding("style.--offset3")  public offset3: number = 0;

  @Input('label') public label: string;
  @Input('text') public text: string;
  
  private _animate: string = 'animate';
  
  constructor(private changeDetectorRef: ChangeDetectorRef) { }

  @Input() public set value1(value: number) {
    this.offset1 = 283 - 283 * this.toFaktor(value);
  }

  @Input() public set value2(value: number) {
    this.offset2 = 239 - 239 * this.toFaktor(value);
  }

  @Input() public set value3(value: number) {
    this.offset3 = 195 - 195 * this.toFaktor(value);
  }

  public get animate(): string {
    return this._animate;
  }

  public set animate(anim: string) {
    this._animate = anim;
  }

  // value < 0 hides; 0 makes a dot
  private toFaktor(value): number {
    if ( value < 0 ) {
      return 0;
    }
    const fact = value / 100;
    if ( fact < 0.001 ) {
      return 0.001
    }
    return fact; 
  };

  public doAanimate() {
    this.animate = '';
    this.changeDetectorRef.detectChanges();
    setTimeout(() => {
      this.animate = 'reanimate';
      this.changeDetectorRef.detectChanges();
    }, 100);
  }
}
